/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Alert_TextInputs */



/**
* | output |
* | --- |
* | "This is an alert message." |
*
* @param {Iframe_Remote_Alert_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_alert_text = /** @type {((inputs?: Iframe_Remote_Alert_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Alert_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ceci est un message d'alerte.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dies ist eine Warnmeldung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo è un messaggio di avviso.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Это предупреждающее сообщение.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este es un mensaje de alerta.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("这是一条警报信息。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("これは警告メッセージです。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह एक चेतावनी संदेश है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Esta é uma mensagem de alerta.")
	return /** @type {LocalizedString} */ ("This is an alert message.")
});